export default {
  applyCode: "Apply",
  promoCode: "Promo code",
  promoSuccessful: "Promo successful!",
  removeCode: "Remove code"
};
